import React, {ReactElement} from 'react';
import {PressEventProvider, PressEventProps} from 'components/PressEventProvider';
import {Container, Label} from './style';

interface DeleteButtonProps {
  onPress: () => void;
}

export const DeleteButton = ({onPress}: DeleteButtonProps): ReactElement => (
  <PressEventProvider onPress={onPress}>
    {(props: PressEventProps) => (
      <Container data-test='delete-button' {...props}>
        <Label>Удалить</Label>
      </Container>
    )}
  </PressEventProvider>
);
